/**
 * Physical table sides for the live score pad.
 *
 * Rules (standard club play):
 * - Swap ends after every completed set.
 * - In the deciding set (2–2 best-of-5, or 3–3 best-of-7), swap once when
 *   either side reaches 5 points in that set.
 *
 * `manualFlip` inverts the automatic orientation (scorer correction).
 */
export function computeScoreboardSides({
  homeSets = 0,
  awaySets = 0,
  liveHome = 0,
  liveAway = 0,
  setsToWin = 3,
  manualFlip = false,
} = {}) {
  const hs = Math.max(0, Number(homeSets) || 0);
  const as = Math.max(0, Number(awaySets) || 0);
  const lh = Math.max(0, Number(liveHome) || 0);
  const la = Math.max(0, Number(liveAway) || 0);
  const need = Math.max(2, Number(setsToWin) || 3);

  const completedSets = hs + as;
  const decidingSet = hs === need - 1 && as === need - 1;
  const fivePointFlip = decidingSet && (lh >= 5 || la >= 5);
  const autoSwapped = (completedSets + (fivePointFlip ? 1 : 0)) % 2 === 1;
  const swapped = manualFlip ? !autoSwapped : autoSwapped;

  return {
    swapped,
    leftSide: swapped ? "away" : "home",
    rightSide: swapped ? "home" : "away",
    decidingSet,
    fivePointFlip,
    /** Show “change ends” cue before the 5-point flip happens. */
    pendingFivePointChange: decidingSet && !fivePointFlip,
    completedSets,
    setsToWin: need,
  };
}
